define('taoQtiItem/qtiItem/core/qtiClasses',[], function(){
    return {
        '_container' : 'taoQtiItem/qtiItem/core/Container',
        'assessmentItem' : 'taoQtiItem/qtiItem/core/Item',
        'responseProcessing' : 'taoQtiItem/qtiItem/core/ResponseProcessing',
        '_simpleFeedbackRule' : 'taoQtiItem/qtiItem/core/response/SimpleFeedbackRule',
        'stylesheet' : 'taoQtiItem/qtiItem/core/Stylesheet',
        'math' : 'taoQtiItem/qtiItem/core/Math',
        'img' : 'taoQtiItem/qtiItem/core/Img',
        'object' : 'taoQtiItem/qtiItem/core/Object',
        'outcomeDeclaration' : 'taoQtiItem/qtiItem/core/variables/OutcomeDeclaration',
        'responseDeclaration' : 'taoQtiItem/qtiItem/core/variables/ResponseDeclaration',
        'rubricBlock' : 'taoQtiItem/qtiItem/core/RubricBlock',
        'associableHotspot' : 'taoQtiItem/qtiItem/core/choices/AssociableHotspot',
        'gap' : 'taoQtiItem/qtiItem/core/choices/Gap',
        'gapImg' : 'taoQtiItem/qtiItem/core/choices/GapImg',
        'gapText' : 'taoQtiItem/qtiItem/core/choices/GapText',
        'hotspotChoice' : 'taoQtiItem/qtiItem/core/choices/HotspotChoice',
        'hottext' : 'taoQtiItem/qtiItem/core/choices/Hottext',
        'inlineChoice' : 'taoQtiItem/qtiItem/core/choices/InlineChoice',
        'simpleAssociableChoice' : 'taoQtiItem/qtiItem/core/choices/SimpleAssociableChoice',
        'simpleChoice' : 'taoQtiItem/qtiItem/core/choices/SimpleChoice',
        'associateInteraction' : 'taoQtiItem/qtiItem/core/interactions/AssociateInteraction',
        'choiceInteraction' : 'taoQtiItem/qtiItem/core/interactions/ChoiceInteraction',
        'endAttemptInteraction' : 'taoQtiItem/qtiItem/core/interactions/EndAttemptInteraction',
        'extendedTextInteraction' : 'taoQtiItem/qtiItem/core/interactions/ExtendedTextInteraction',
        'gapMatchInteraction' : 'taoQtiItem/qtiItem/core/interactions/GapMatchInteraction',
        'graphicAssociateInteraction' : 'taoQtiItem/qtiItem/core/interactions/GraphicAssociateInteraction',
        'graphicGapMatchInteraction' : 'taoQtiItem/qtiItem/core/interactions/GraphicGapMatchInteraction',
        'graphicOrderInteraction' : 'taoQtiItem/qtiItem/core/interactions/GraphicOrderInteraction',
        'hotspotInteraction' : 'taoQtiItem/qtiItem/core/interactions/HotspotInteraction',
        'hottextInteraction' : 'taoQtiItem/qtiItem/core/interactions/HottextInteraction',
        'inlineChoiceInteraction' : 'taoQtiItem/qtiItem/core/interactions/InlineChoiceInteraction',
        'matchInteraction' : 'taoQtiItem/qtiItem/core/interactions/MatchInteraction',
        'mediaInteraction' : 'taoQtiItem/qtiItem/core/interactions/MediaInteraction',
        'orderInteraction' : 'taoQtiItem/qtiItem/core/interactions/OrderInteraction',
        'prompt' : 'taoQtiItem/qtiItem/core/interactions/Prompt',
        'selectPointInteraction' : 'taoQtiItem/qtiItem/core/interactions/SelectPointInteraction',
        'sliderInteraction' : 'taoQtiItem/qtiItem/core/interactions/SliderInteraction',
        'textEntryInteraction' : 'taoQtiItem/qtiItem/core/interactions/TextEntryInteraction',
        'uploadInteraction' : 'taoQtiItem/qtiItem/core/interactions/UploadInteraction',
        'feedbackBlock' : 'taoQtiItem/qtiItem/core/feedbacks/FeedbackBlock',
        'feedbackInline' : 'taoQtiItem/qtiItem/core/feedbacks/FeedbackInline',
        'modalFeedback' : 'taoQtiItem/qtiItem/core/feedbacks/ModalFeedback',
        'customInteraction' : 'taoQtiItem/qtiItem/core/interactions/CustomInteraction',
        'infoControl' : 'taoQtiItem/qtiItem/core/PortableInfoControl',
        'include' : 'taoQtiItem/qtiItem/core/Include',
        'table' : 'taoQtiItem/qtiItem/core/Table'
    };
});
